import React, { useState, useEffect } from "react";
import DataValidation, { DATA_VALIDATION_TYPES } from "../../../RestaurantWidget/utilities/helper/dataValidation";
import { useHistory } from 'react-router'
import { Checkbox, Col, InputBox, Label, Row, Space, Typography } from 'witmeg-ui-system'
import { LOCAL_STORAGE_ITEMS_NAMES, setLocalStorageData } from "../../../RestaurantWidget/utilities/helper/helper";
import { useSelector } from "react-redux";
import cartIc from "../../assets/cart-gray.svg"
import arrow from "../../assets/images/down-arrow.svg"
import Footer from "../../components/Footer/Footer";
import PhoneInput from 'react-phone-number-input'
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import IMAGE_PLACEHOLDER from "../../assets/images/Images/empty-placeholder.png"
import Modal from "../../components/Modal/Modal";

const VoucherMenuDefaultOrderConfirmationPage = () => {
    const restaurantDataState = useSelector((state) => state.resturantData);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const {
        selectedOrderType
    } = useSelector((state) => state.resturantData);
    const userDetails = localStorage.getItem('fullUserDetails')
    let parsedUserDetails = JSON.parse(localStorage.getItem('fullUserDetails'))
    const userDetailsDelivery = localStorage.getItem('DELIVERY_DATA')
    let parsedUserDetailsDelivery = JSON.parse(localStorage.getItem('DELIVERY_DATA'))
    const phoneNumberAddress = userDetails ? parsedUserDetails?.Addresses[0]?.Phone || "" : ""
    const isCartDataAvailable = restaurantDataState.orderCartData && restaurantDataState.orderCartData.Items.length ? true : false;
    const address = userDetails ? parsedUserDetails.Addresses.find((address) => address.AddressType === "Billing") : null
    const addressDelivery = selectedOrderType === "delivery" ? userDetailsDelivery ? parsedUserDetailsDelivery.Addresses.find((address) => address.AddressType === "Delivery") : null : userDetails ? parsedUserDetails.Addresses.find((address) => address.AddressType === "Delivery") : null
    let useDeliveryForBilling = companyDetails?.settings?.OnlineOrder?.Delivery?.UseDeliveryForBilling && selectedOrderType === "delivery"

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const getNationalNumber = (phone) => {
        if (!phone) return '';
        try {
            const parsed = parsePhoneNumberFromString(phone);
            return parsed ? parsed.nationalNumber : phone;
        } catch (error) {
            return phone;
        }
    };
    const customerDetailsInitialState = {
        firstName: {
            value: userDetails ? parsedUserDetails.FirstName : "",
            hasError: false,
            errorType: null,
            errorMessage: null,
            validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_TEXT_ONLY],
        },
        lastName: {
            value: userDetails ? parsedUserDetails.LastName : "",
            hasError: false,
            errorType: null,
            errorMessage: null,
            validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_TEXT_ONLY],
        },
        mobileNo: {
            value: phoneNumberAddress ? "+44" + phoneNumberAddress ?? "" : "",
            hasError: false,
            errorType: null,
            errorMessage: null,
            errorMessage: null,
            validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_PHONE_NO],
        },
        emailAddress: {
            value: userDetails ? parsedUserDetails.Email : "",
            hasError: false,
            errorType: null,
            errorMessage: null,
            validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_EMAIL],
        },
        customerAddress: {
            line1: {
                value: useDeliveryForBilling ? addressDelivery?.AddressLine1 || "" : address ? address.AddressLine1 : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
            },
            line2: {
                value: useDeliveryForBilling ? addressDelivery?.AddressLine2 || "" : address ? address.AddressLine2 : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            state: {
                value: useDeliveryForBilling ? addressDelivery?.StateProvinceRegion || "" : address ? address.StateProvinceRegion : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: useDeliveryForBilling ? [] : [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
            },
            city: {
                value: useDeliveryForBilling ? addressDelivery?.City || "" : address ? address.City : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
            },
            postcode: {
                value: useDeliveryForBilling ? addressDelivery?.PostZipCode || "" : address ? address.PostZipCode : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_POSTCODE],
            },
            country: {
                value: 'United Kingdom',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
        },
        deliveryAddress: {
            line1: {
                value: addressDelivery?.AddressLine1 || "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            line2: {
                value: addressDelivery?.AddressLine2 || "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            state: {
                value: addressDelivery?.StateProvinceRegion || "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            city: {
                value: addressDelivery?.City || "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            postcode: {
                value: addressDelivery?.PostZipCode || '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [],
            },
            country: {
                value: 'United Kingdom',
                hasError: false,
                errorType: null,
                errorMessage: null,
                // validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
                validations: [],
            },
        },
        isDeliveryAddressSame: useDeliveryForBilling ? true : false,
    };
    let history = useHistory();
    const [orderType, setOrderType] = useState(restaurantDataState.orderDetails.FulfillmentType)
    const [customerDetails, setCustomerDetails] = useState(customerDetailsInitialState);
    const [isCollapsed, setIsCollapsed] = useState("closed")
    const [showErrorModal, setShowErrorModal] = useState(false)

    const getPrice = (
        basePrice
    ) => {
        let priceValue;
        switch (orderType) {
            case "DELIVERY_BY_REWARDCONSUMER":
                priceValue = basePrice.Delivery.FormattedText;
                break;
            case "DINE_IN":
                priceValue = basePrice.DineIn.FormattedText;
                break;
            case "TAKE_AWAY":
                priceValue = basePrice.TakeAway.FormattedText;
                break;
            default:
                priceValue = basePrice.Delivery.FormattedText;
                break;
        }
        return priceValue
    }
    const renderModifierGroups = (selectedGroup, item) => {
        return (
            <div>
                {selectedGroup.SelectedItems.map((selectedItem, index) => (
                    <span key={index}>
                        <span className="addon-title">
                            {selectedItem.Title.replace(/\.+$/, '')} <span className="qty-box">{Math.floor(selectedItem.Quantity.Amount / item.Quantity.Amount)}</span>
                        </span>
                        {selectedItem.SelectedModifierGroups && selectedItem.SelectedModifierGroups.length > 0 && (
                            <span>
                                {selectedItem.SelectedModifierGroups.map((nestedGroup, nestedIndex) => (
                                    <span key={nestedIndex}> {renderModifierGroups(nestedGroup, item)}</span>
                                ))}
                            </span>
                        )}
                        {index < selectedGroup.SelectedItems.length - 1 && <span>, </span>}
                    </span>
                ))}
            </div>
        );
    };
    const onFormDataChanged = (property, value) => {
        setCustomerDetails((prevState) => {
            const [key, subKey] = property.split('.');

            if (subKey) {
                return {
                    ...prevState,
                    [key]: {
                        ...prevState[key],
                        [subKey]: {
                            ...prevState[key][subKey],
                            value,
                            errorMessage: "",
                            hasError: false
                        },
                    },
                };
            }

            return {
                ...prevState,
                [property]: {
                    ...prevState[property],
                    value,
                    errorMessage: "",
                    hasError: false

                },
            };
        });
    };
    const toggleIsDeliveryAddressDifferent = () => {
        setCustomerDetails(prevState => ({
            ...prevState,
            isDeliveryAddressSame: !prevState.isDeliveryAddressSame,
        }));
    };
    const getErrorMessage = (type) => {
        let message = ""
        switch (type) {
            case 'REQUIRED_FIELD':
                message = "This field is required."
                break;
            case 'IS_EMAIL':
                message = "Please enter a valid email address."
                break;
            case 'IS_TEXT_ONLY':
                message = "Input must contain letters only"
                break;
            case 'IS_POSTCODE':
                message = "Please enter a valid Postcode."
                break;
            case 'IS_PHONE_NO':
                message = "Please enter a valid Phonenumber."
                break;
            default:
                break;
        }
        return message
    }
    const validateFieldSet = (fields) => {
        let pageHasError = false;
        const newFields = { ...fields };

        for (const key in fields) {
            if (!fields.hasOwnProperty(key)) continue;

            let validationRes = { hasError: false, errorType: null };

            for (const validation of fields[key].validations) {
                if (validationRes.hasError) break;

                validationRes = DataValidation(validation, fields[key].value, fields[key].additional ?? null);
                fields[key].errorMessage = getErrorMessage(validationRes.errorType)
            }

            if (validationRes.hasError) pageHasError = true;

            newFields[key] = {
                ...newFields[key],
                ...validationRes,
            };
        }

        return {
            fields: newFields,
            hasError: pageHasError,
        };
    };


    const validateAllFormData = () => {
        return new Promise((resolve) => {
            let pageError = false;

            setCustomerDetails(prevState => {
                const { customerAddress, deliveryAddress, isDeliveryAddressSame, ...basicFields } = prevState;
                const newBasic = validateFieldSet(basicFields);
                const newCustomerAddress = validateFieldSet(customerAddress);
                const newDeliveryAddress = isDeliveryAddressSame
                    ? { fields: customerAddress, hasError: false }
                    : validateFieldSet(deliveryAddress);

                const pageHasError = newBasic.hasError || newCustomerAddress.hasError;
                pageError = pageHasError;

                if (!pageHasError) {
                    const customerFormData = {
                        ID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                        Name: {
                            DisplayName: basicFields.firstName.value,
                            FirstName: basicFields.firstName.value,
                            LastName: basicFields.lastName.value,
                        },
                        Email: basicFields.emailAddress.value,
                        Contact: {
                            Number: getNationalNumber(basicFields.mobileNo.value.replace("+44", "")),
                            PinCode: "+44",
                            CountryISO2: "GB"
                        },
                        BillingAddress: {
                            Id: "",
                            AddressType: "",
                            AddressLine1: useDeliveryForBilling ? deliveryAddress.line1?.value || "" : customerAddress.line1.value,
                            AddressLine2: useDeliveryForBilling ? deliveryAddress.line2?.value || "" : customerAddress.line2?.value || '',
                            StateProvinceRegion: useDeliveryForBilling ? deliveryAddress.state?.value || "" : customerAddress.state.value,
                            PostZipCode: useDeliveryForBilling ? deliveryAddress.postcode?.value || "" : customerAddress.postcode.value,
                            Country: useDeliveryForBilling ? deliveryAddress.country?.value || "" : customerAddress.country.value,
                            City: useDeliveryForBilling ? deliveryAddress.city?.value || "" : customerAddress.city.value,
                            CountryCode: "",
                            AddressLabel: "",
                            Longitude: 0,
                            Latitude: 0,
                            Additional: {
                                Instruction: "",
                                InteractionType: ""
                            }
                        },
                        DeliveryAddress: {
                            Id: "",
                            AddressType: "",
                            AddressLine1: isDeliveryAddressSame ? customerAddress.line1.value : deliveryAddress.line1?.value,
                            AddressLine2: isDeliveryAddressSame ? customerAddress.line2.value || '' : deliveryAddress.line2?.value || '',
                            StateProvinceRegion: isDeliveryAddressSame ? customerAddress.state.value : deliveryAddress.state?.value,
                            PostZipCode: isDeliveryAddressSame ? customerAddress.postcode.value : deliveryAddress.postcode?.value,
                            Country: isDeliveryAddressSame ? customerAddress.country.value : deliveryAddress.country?.value,
                            City: isDeliveryAddressSame ? customerAddress.city.value : deliveryAddress.city?.value,
                            CountryCode: "",
                            AddressLabel: "",
                            Longitude: 0,
                            Latitude: 0,
                            Additional: {
                                Instruction: "",
                                InteractionType: ""
                            }
                        },
                    };
                    let data = {
                        "UserID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                        "CompanyName": "",
                        "UserName": basicFields.firstName.value.toLowerCase(),
                        "FirstName": basicFields.firstName.value,
                        "LastName": basicFields.lastName.value,
                        "Addresses": [
                            {
                                "AddressType": "Billing",
                                "HouseNo": "",
                                "AddressLine1": useDeliveryForBilling ? deliveryAddress.line1?.value || "" : customerAddress.line1.value,
                                "AddressLine2": useDeliveryForBilling ? deliveryAddress.line2?.value || "" : customerAddress.line2?.value || "",
                                "City": useDeliveryForBilling ? deliveryAddress.city?.value || "" : customerAddress.city.value || "",
                                "StateProvinceRegion": useDeliveryForBilling ? deliveryAddress.state?.value || "" : customerAddress.state.value,
                                "PostZipCode": useDeliveryForBilling ? deliveryAddress.postcode?.value || "" : customerAddress.postcode.value,
                                "Country": useDeliveryForBilling ? deliveryAddress.country?.value || "" : customerAddress.country.value,
                                "Phone": getNationalNumber(basicFields.mobileNo.value.replace("+44", "")),
                                "Fax": "",
                                "Email": basicFields.emailAddress.value,
                                "CreatedDate": "",
                                "LastModifiedDate": "",
                                "IsDefault": false,
                                "IsActive": false,
                                "TelephoneCode": "+44",
                                "AddressLabel": ""
                            },
                            {
                                "AddressType": "Delivery",
                                "HouseNo": "",
                                "AddressLine1": isDeliveryAddressSame ? customerAddress.line1.value : deliveryAddress.line1?.value,
                                "AddressLine2": isDeliveryAddressSame ? (customerAddress.line2?.value || "") : (deliveryAddress.line2?.value || ""),
                                "City": isDeliveryAddressSame ? (customerAddress.city?.value || "") : (deliveryAddress.city?.value || ""),
                                "StateProvinceRegion": isDeliveryAddressSame ? customerAddress.state.value : deliveryAddress.state?.value,
                                "PostZipCode": isDeliveryAddressSame ? customerAddress.postcode.value : deliveryAddress.postcode?.value,
                                "Country": isDeliveryAddressSame ? customerAddress.country.value : deliveryAddress.country?.value,
                                "Phone": getNationalNumber(basicFields.mobileNo.value.replace("+44", "")),
                                "Fax": "",
                                "Email": basicFields.emailAddress.value,
                                "CreatedDate": "",
                                "LastModifiedDate": "",
                                "IsDefault": false,
                                "IsActive": false,
                                "TelephoneCode": "+44",
                                "AddressLabel": ""
                            }
                        ],
                        "Email": basicFields.emailAddress.value,
                    }
                    localStorage.setItem("fullUserDetails", JSON.stringify(data))


                    setLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS, customerFormData);
                }
                return {
                    ...prevState,
                    ...newBasic.fields,
                    customerAddress: newCustomerAddress.fields,
                    deliveryAddress: newDeliveryAddress.fields,
                };
            });

            setTimeout(() => resolve(pageError), 0);
        });
    };



    const getErrorFields = (state) => {
        const errorFields = [];

        for (const key in state) {
            const field = state[key];
            if (field && field.hasError) {
                errorFields.push(key);
            }

            if (typeof field === 'object') {
                for (const subKey in field) {
                    const subField = field[subKey];
                    if (subField && subField.hasError) {
                        errorFields.push(`${key}.${subKey}`);
                    }
                }
            }
        }

        return errorFields;
    }
    const formatFieldNames = (fields) => {
        return fields.map(field => {
            return field
                .split('.')
                .map(part => part.charAt(0).toUpperCase() + part.slice(1).replace(/([A-Z])/g, ' $1'))
                .join(' ');
        });
    }
    const getErrorMessages = () => {
        let fields = getErrorFields(customerDetails)
        console.log(fields, customerDetails)

        let formattedFileds = formatFieldNames(fields)
        let message = ""
        if (formattedFileds.length > 2) {
            message = "There are multiple fields missing. Please fill in all the required fields to continue."
        } else {
            message = `${formattedFileds.join(", ")}  ${formattedFileds.length === 1 ? "is" : "are"} missing. Please fill in all the required fields to continue.`
        }
        return message
    }
    return (
        <div className="Order-confirmation">
            <div className="Order-confirmation-header">
                <div className="header-text-cont">Order Confirmation</div>
            </div>
            <div className="Order-confirmation-inner">
                <div className="eco-mb-16 Order-confirmation-inner-left">

                    <div className="order-form-summary ">
                        <div className="form-header">Contact Details</div>
                        <div className="order-form-container order-det">
                            <div className="personal-header">Personal Details</div>
                            <Row className="eco-mb-24" gutter={[16, 16]}>
                                <Col lg={12} sm={24} xs={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>First Name</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox
                                                onChange={(e) => onFormDataChanged('firstName', e.target.value)}
                                                type="text"
                                                value={customerDetails.firstName.value}
                                                error={customerDetails.firstName.hasError}
                                                disabled={localStorage.getItem('isLogged') === 'true'}

                                            />
                                            <div className="error-text">{customerDetails.firstName.errorMessage}</div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12} sm={24} xs={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>Last Name</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox onChange={(e) => onFormDataChanged('lastName', e.target.value)} type="text" value={customerDetails.lastName.value} error={customerDetails.lastName.hasError}
                                                disabled={localStorage.getItem('isLogged') === 'true'}
                                            />
                                            <div className="error-text">{customerDetails.lastName.errorMessage}</div>

                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="eco-mb-24" gutter={[16, 16]}>
                                <Col lg={12} sm={24} xs={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>Email Address</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox onChange={(e) => onFormDataChanged('emailAddress', e.target.value)}
                                                disabled={localStorage.getItem('isLogged') === 'true'}
                                                type="text" value={customerDetails.emailAddress.value} error={customerDetails.emailAddress.hasError} />
                                            <div className="error-text">{customerDetails.emailAddress.errorMessage}</div>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12} sm={24} xs={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>Mobile Number</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <PhoneInput
                                                defaultCountry="GB"
                                                placeholder=""
                                                value={customerDetails.mobileNo.value}
                                                onChange={
                                                    (e) => onFormDataChanged('mobileNo', e)
                                                }
                                                className={customerDetails.mobileNo.hasError ? "validate" : ""}

                                            />
                                            <div className="error-text">{customerDetails.mobileNo.errorMessage}</div>

                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <div className="personal-header">Billing Address</div>
                            <Row className="eco-mb-24" gutter={[16, 16]}>
                                <Col span={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>Address Line 1</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox
                                                disabled={useDeliveryForBilling}
                                                onChange={(e) => onFormDataChanged('customerAddress.line1', e.target.value)} type="text" value={customerDetails.customerAddress.line1.value} error={customerDetails.customerAddress.line1.hasError} />
                                            <div className="error-text">{customerDetails.customerAddress.line1.errorMessage}</div>

                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="eco-mb-24">
                                <Col span={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label>Address Line 2</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox
                                                disabled={useDeliveryForBilling}
                                                onChange={(e) => onFormDataChanged('customerAddress.line2', e.target.value)} type="text" value={customerDetails.customerAddress.line2.value} error={customerDetails.customerAddress.line2.hasError} />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="eco-mb-24" gutter={[16, 16]}>
                                <Col lg={12} sm={24} xs={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>Postcode</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox
                                                disabled={useDeliveryForBilling}
                                                onChange={(e) => onFormDataChanged('customerAddress.postcode', e.target.value)} type="text" value={customerDetails.customerAddress.postcode.value} error={customerDetails.customerAddress.postcode.hasError} />
                                            <div className="error-text">{customerDetails.customerAddress.postcode.errorMessage}</div>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12} sm={24} xs={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required>City</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox
                                                disabled={useDeliveryForBilling}
                                                onChange={(e) => onFormDataChanged('customerAddress.city', e.target.value)} type="text" value={customerDetails.customerAddress.city.value} error={customerDetails.customerAddress.city.hasError} />
                                            <div className="error-text">{customerDetails.customerAddress.city.errorMessage}</div>

                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                            <Row className="eco-mb-24" gutter={[16, 16]}>
                                <Col lg={12} sm={24} xs={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label required={useDeliveryForBilling ? false : true}>State</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox
                                                disabled={useDeliveryForBilling}

                                                onChange={(e) => onFormDataChanged('customerAddress.state', e.target.value)} type="text" value={customerDetails.customerAddress.state.value} error={customerDetails.customerAddress.state.hasError} />
                                            <div className="error-text">{customerDetails.customerAddress.state.errorMessage}</div>

                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12} sm={24} xs={24}>
                                    <Row className="form-row">
                                        <Col span={24}>
                                            <div className="form-lbl-wrapper"><Label>Country</Label></div>
                                        </Col>
                                        <Col span={24}>
                                            <InputBox type="text" value={customerDetails.customerAddress.country.value} disabled />
                                            {/* <Select noBorder onChange={(value) => onFormDataChanged('customerAddress.country', value)} options={pageState.countryData} value={customerDetails.customerAddress.country.value} hasError={customerDetails.customerAddress.country.hasError} placeholder="" /> */}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>


                            {/* {selectedOrderType === "delivery" && <Space size="middle" className="setsame-cont">
                                <Checkbox checked={customerDetails.isDeliveryAddressSame} onChange={(e) => toggleIsDeliveryAddressDifferent()} />
                                <div className="setsame-text">Set the same for delivery</div>
                            </Space>} */}

                            {selectedOrderType === "delivery" &&
                                <div>
                                    <div className="personal-header">Delivery Address</div>

                                    <Row className="eco-mb-24" gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Row className="form-row">
                                                <Col span={24}>
                                                    <div className="form-lbl-wrapper"><Label required>Address Line 1</Label></div>
                                                </Col>
                                                <Col span={24}>
                                                    <InputBox disabled onChange={(e) => onFormDataChanged('deliveryAddress.line1', e.target.value)} type="text" value={customerDetails.deliveryAddress.line1.value} error={customerDetails.deliveryAddress.line1.hasError} />
                                                    <div className="error-text">{customerDetails.deliveryAddress.line1.errorMessage}</div>

                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="eco-mb-24">
                                        <Col span={24}>
                                            <Row className="form-row">
                                                <Col span={24}>
                                                    <div className="form-lbl-wrapper"><Label>Address Line 2</Label></div>
                                                </Col>
                                                <Col span={24}>
                                                    <InputBox disabled onChange={(e) => onFormDataChanged('deliveryAddress.line2', e.target.value)} type="text" value={customerDetails.deliveryAddress.line2.value} error={customerDetails.deliveryAddress.line2.hasError} />

                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="eco-mb-24" gutter={[16, 16]}>

                                        <Col lg={12} sm={24} xs={24}>
                                            <Row className="form-row">
                                                <Col span={24}>
                                                    <div className="form-lbl-wrapper"><Label >Postcode</Label></div>
                                                </Col>
                                                <Col span={24}>
                                                    <InputBox disabled onChange={(e) => onFormDataChanged('deliveryAddress.postcode', e.target.value)} type="text" value={customerDetails.deliveryAddress.postcode.value} error={customerDetails.deliveryAddress.postcode.hasError} />
                                                    <div className="error-text">{customerDetails.deliveryAddress.postcode.errorMessage}</div>

                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col lg={12} sm={24} xs={24}>
                                            <Row className="form-row">
                                                <Col span={24}>
                                                    <div className="form-lbl-wrapper"><Label required>City</Label></div>
                                                </Col>
                                                <Col span={24}>
                                                    <InputBox disabled onChange={(e) => onFormDataChanged('deliveryAddress.city', e.target.value)} type="text" value={customerDetails.deliveryAddress.city.value} error={customerDetails.deliveryAddress.city.hasError} />
                                                    <div className="error-text">{customerDetails.deliveryAddress.city.errorMessage}</div>

                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="eco-mb-24" gutter={[16, 16]}>
                                        <Col lg={12} sm={24} xs={24}>
                                            <Row className="form-row">
                                                <Col span={24}>
                                                    <div className="form-lbl-wrapper"><Label >State</Label></div>
                                                </Col>
                                                <Col span={24}>
                                                    <InputBox disabled onChange={(e) => onFormDataChanged('deliveryAddress.state', e.target.value)} type="text" value={customerDetails.deliveryAddress.state.value} error={customerDetails.deliveryAddress.state.hasError} />
                                                    <div className="error-text">{customerDetails.deliveryAddress.state.errorMessage}</div>

                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col lg={12} sm={24} xs={24}>
                                            <Row className="form-row">
                                                <Col span={24}>
                                                    <div className="form-lbl-wrapper"><Label>Country</Label></div>
                                                </Col>
                                                <Col span={24}>
                                                    <InputBox type="text" value={customerDetails.deliveryAddress.country.value} disabled />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="Order-confirmation-inner-right ">
                    {isCartDataAvailable ?
                        <div className="order-form-summary " style={{ marginTop: "72px" }}>
                            <div className="order-form-container">
                                <div className="form-header-text">Order Summary</div>
                                {isCartDataAvailable &&
                                    <>
                                        <div className="header-conater"><div className="header-conater-left">
                                            <img alt="" src={cartIc} />
                                            <div className="form-header-text-cont">Cart Items</div>
                                            <div className="text-sub ">({restaurantDataState.orderCartData.Items.length} {restaurantDataState.orderCartData.Items.length === 1 ? "item" : "items"})</div></div>
                                            <div className="header-conater-right"><img alt="" src={arrow} className={`arrow-${isCollapsed}`} onClick={() => {
                                                if (isCollapsed === "open") {
                                                    setIsCollapsed("closed")
                                                } else {
                                                    setIsCollapsed("open")
                                                }
                                            }} /></div></div>
                                        {isCollapsed === "open" && <div className="order-cart-list">
                                            {isCartDataAvailable && restaurantDataState.orderCartData.Items.map((item, index) => {
                                                const _hasAddons = item.SelectedModifierGroups.length > 0;
                                                return (
                                                    <div className="order-cart-item" key={index}>
                                                        <div className="order-cart-item-left">
                                                            <div className="cart-item-image-cont">

                                                                <Typography
                                                                    style={{ backgroundImage: `url(${item.PictureURL !== "" ? item.PictureURL : IMAGE_PLACEHOLDER})`, objectFit: item.PictureURL === "" ? "fill" : "" }}
                                                                    className="cart-item-image">
                                                                </Typography>
                                                            </div>
                                                            <div className='item-details-container-left'>
                                                                <div className='item-cart-title truncate-text'>{item.Title}</div>
                                                                <div className="modifiers-text">
                                                                    {_hasAddons && item.SelectedModifierGroups.map((selectedGroup, index) => (
                                                                        <span key={index}> {renderModifierGroups(selectedGroup, item)} </span>
                                                                    ))}
                                                                </div>
                                                                <div className='item-cart-price'>   {getPrice(item.PriceInfo.TotalPrice)}</div>
                                                            </div>
                                                        </div>
                                                        <div className="order-cart-item-right">
                                                            <div className="qty-container">
                                                                {item.Quantity.Amount}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>}

                                    </>}
                                <div className="price-list">
                                    <div className="form-header-text">Order Total</div>
                                    <div className="price-list-inner">
                                        <div className="price-list-inner-left">Sub total</div>
                                        <div className="price-list-inner-right">     {restaurantDataState.orderDetails.Payment.
                                            PaymentDetail.OrderTotal.Net.Formatted}</div>

                                    </div>
                                    {restaurantDataState?.orderDetails?.Payment.
                                        PaymentDetail?.Fee?.Details?.map((fee, key) => {
                                            return (
                                                <div className="price-list-inner" key={key}>
                                                    <div className="price-list-inner-left">{fee.Description}</div>
                                                    <div className="price-list-inner-right">
                                                        {fee.Amount.DisplayAmount}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                </div>
                                <div className="price-list">
                                    <div className="price-list-inner-total" >
                                        <div className="total-value-text ">Total Price</div>
                                        <div className="total-value-text ">
                                            {restaurantDataState.orderDetails.Payment.
                                                PaymentDetail.OrderTotal.Gross.Formatted}
                                        </div>
                                    </div>
                                </div>
                                <div className="custom-btn-order" onClick={() => {
                                    validateAllFormData().then((error) => {
                                        if (!error) {
                                            history.push('/order/summary');
                                        }
                                        else {

                                            setShowErrorModal(true)
                                        }
                                    })

                                }}>Continue to Payment</div>
                            </div>
                        </div> : ""}
                </div>
            </div>
            <Footer />
            <Modal visibility={showErrorModal} type="failed" headerText="Required fields are missing." subText={getErrorMessages()} onPopupClose={() => {
                setShowErrorModal(false)
            }} />
        </div>
    )
}
export default VoucherMenuDefaultOrderConfirmationPage